console.log("hogehogehogehogehoge");
$('.modal-open').click(function(){
  $(this).next().addClass('is-open');
})

$('.modal').click(function(){
  $(this).removeClass('is-open');
});